import { render, staticRenderFns } from "./BlockOpportunity.vue?vue&type=template&id=2ec47b6c&scoped=true&"
import script from "./BlockOpportunity.vue?vue&type=script&lang=js&"
export * from "./BlockOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./BlockOpportunity.vue?vue&type=style&index=0&id=2ec47b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec47b6c",
  null
  
)

export default component.exports